import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { formatMinutes } from "../../../../app/datetimeUtils";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import FormattedDateAndTime from "../../../../components/FormattedDateAndTime";
import { TutorialUsageByCategory, TutorialUsage } from "./UsageFilteredByCourseViewModel";

export function LessonCategoryUsageTable(props: {
	className?: string;
	courseId: number;
	tutorialUsageByCategory: TutorialUsageByCategory[];
	tutorialUsageForCourse: TutorialUsage;
}) {
	const lastUsedDateTemplate = (rowData: TutorialUsageByCategory) => {
		return <FormattedDateAndTime date={rowData.lastUsedDate} />;
	};

	const categoryBodyTemplate = (rowData: TutorialUsageByCategory) => {
		return (
			<Link
				className="link"
				to={`/reports/course/usage/lessonCategory?categoryId=${rowData.tutorialCategoryId}&courseId=${props.courseId}`}>
				{rowData.tutorialCategoryName}
			</Link>
		);
	};

	const timeSpentBodyTemplate = (rowData: TutorialUsageByCategory) => {
		return formatMinutes(rowData.timeSpentMinutes);
	};

	const hasData = props.tutorialUsageByCategory && props.tutorialUsageByCategory.length > 0;

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Total Time" colSpan={2} footerClassName="font-medium !text-right" />
				<Column
					footer={formatMinutes(props.tutorialUsageForCourse.timeSpentMinutes)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<DataTable
			value={props.tutorialUsageByCategory}
			dataKey="tutorialCategoryId"
			loading={props.tutorialUsageByCategory == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header="Most Recent Use"
				body={lastUsedDateTemplate}
				sortable
				sortField="lastUsedDate"></Column>
			<Column
				header="Category"
				body={categoryBodyTemplate}
				sortable
				sortField="tutorialCategoryName"></Column>
			<Column
				header="Total Time Spent"
				body={timeSpentBodyTemplate}
				sortable
				sortField="timeSpentMinutes"></Column>
		</DataTable>
	);
}
